export default __webpack_public_path__ + "media/images/main-adv/digital-ad00185fa43f30a2b78bdd06bfefb970.svg";